/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_InvalidInputs */

const es_co2_error_email_invalid = /** @type {(inputs: Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El correo electrónico no es válido.`)
};

/**

* @param {Error_Email_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_email_invalid = /** @type {((inputs?: Error_Email_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_email_invalid(inputs)
});